import React, { useState, useEffect } from "react";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import Table from "../../components/Table";

import { GET_PAYMENT_HISTORY_URL, getData } from "../../utils/api";

const TransactionHistory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState({
    limit: 25,
    offset: 0,
    areMoreItemsAvailable: false,
  });
  const [historyItems, setHistoryItems] = useState([]);

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };

  const getTransactionHistory = async () => {
    try {
      setIsLoading(true);
      const data = await getData(GET_PAYMENT_HISTORY_URL, {
        count: params.limit,
        offset: params.offset,
      });
      setIsLoading(false);
      setHistoryItems(data.list);
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
    } catch (e) {
      console.log("ERROR", e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTransactionHistory();
  }, [params.offset, params.text, params.limit]);

  return (
    <>
      <Table
        customClassName="pr-16"
        scrollTable={true}
        columns={[
          "Transaction ID",
          "Plan",
          "Amount",
          "Card",
          "Brand",
          "Expiry",
          "Created",
          "Status",
        ]}
        items={(historyItems || []).map((histroy) => {
          const createdDate = moment(histroy.created).format(
            "MM/DD/YYYY hh:mm A"
          );
          return {
            ...histroy,
            created: `${createdDate}`,
            amount: (
              <CurrencyFormat
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                value={(histroy.amount / 100).toFixed(2)}
              />
            ),
            status: (
              <div
                style={{
                  fontSize: 16,
                  color:
                    histroy?.status && histroy?.status === "success"
                      ? "green"
                      : "red",
                }}
              >
                {histroy?.status?.toUpperCase() || " - "}
              </div>
            ),
          };
        })}
        keys={[
          "transactionId",
          "planName",
          "amount",
          "card",
          "brand",
          "expiry",
          "created",
          "status",
        ]}
        offset={params.offset}
        areMoreItemsAvailable={params.areMoreItemsAvailable}
        fetchMore={fetchMore}
        fetchLess={fetchLess}
        isLoading={isLoading}
        counterDropdown={[25, 50, 100]}
        className="min-wt-1000"
        hideCheckBox={true}
        onCountChange={(value) => {
          setParams({
            ...params,
            limit: value,
          });
        }}
        limit={params.limit}
      />
    </>
  );
};

export default TransactionHistory;
